import { SagaIterator } from "redux-saga";
import { mapTalkSheet } from "src/modules/TalkSheet/helpers";
import { getCall } from "src/services";

type GetTalkSheet = SagaIterator | Promise<unknown>;

export function* getTalkSheet(talkId: string, lng: string): GetTalkSheet {
  const talkSheet = yield getCall({
    url: `/v1/feedback/talk/${talkId}/sheet`,
    params: {
      languageCode: lng
    }
  });
  return mapTalkSheet(talkSheet);
}
